<span [ngClass]="'chip ' + color">
  <ng-content></ng-content>
</span>
